var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{directives:[{name:"dialog-drag",rawName:"v-dialog-drag"}],attrs:{"title":_vm.title,"visible":_vm.showDialog,"width":"860px","destroy-on-close":true,"before-close":_vm.cancel},on:{"update:visible":function($event){_vm.showDialog=$event}}},[_c('mailing-content',{attrs:{"select-detail":_vm.selectDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }